import { scorecardMetricOptions } from './constants';
import type { ParameterDiscoveryMetric } from './types';

interface ScorecardMetricControlProps {
    value: ParameterDiscoveryMetric;
    disabled: boolean;
    hasOptionMetricData: boolean | undefined;
    onChange: (value: ParameterDiscoveryMetric) => void;
}

const ScorecardMetricControl = ({ value, disabled, hasOptionMetricData, onChange }: ScorecardMetricControlProps) => (
    <div className="flex flex-col gap-1">
        <span className="text-xs text-zinc-400">Scorecard Metric</span>
        <div aria-label="Scorecard Metric" className="inline-flex rounded-lg bg-zinc-800 p-1" role="group">
            {scorecardMetricOptions.map((option) => {
                const optionDisabled = disabled || (option.value === 'options' && !hasOptionMetricData);

                return (
                    <button
                        aria-pressed={value === option.value}
                        className={`rounded px-3 py-1.5 text-sm font-medium transition-colors ${
                            value === option.value ? 'bg-zinc-700 text-white' : 'text-zinc-400 hover:text-zinc-200'
                        } ${optionDisabled ? 'cursor-not-allowed opacity-50' : ''}`}
                        disabled={optionDisabled}
                        key={option.value}
                        type="button"
                        onClick={() => onChange(option.value)}
                    >
                        {option.label}
                    </button>
                );
            })}
        </div>
    </div>
);

export default ScorecardMetricControl;
